import React, { useState, useRef, useEffect } from 'react'
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Api from '../../Api.js';
import { useDispatch, useSelector } from "react-redux"
import SeenIcon from './SeenIcon.js';
import moment from "moment-timezone";
import { REACT_SOCKET_URL } from "../../config.js"
import useWebSocket from "../../helpers/useWebSocket.js";
import { messageUpdate } from '../../store/actions/messages.js';

export default function Messages({ room }) {
    const token = useSelector((state) => state.manager.token) || localStorage.getItem('token');
    const [message, setMessages] = useState([])
    const login = useSelector((state) => state.manager.employee);
    const dispatch = useDispatch()
    const { isConnected, messages, isSeen, joinRoom, leaveRoom } = useWebSocket(
        `${REACT_SOCKET_URL}/ws/messages/${room}/`, // or `/ws/messages/`
        token
    );

    const [files, setFiles] = useState([])
    const [value, setValue] = useState("");
    useEffect(() => {
        if (!isConnected || !messages.length) return;
        const lastMessage = messages[messages.length - 1];
        if (lastMessage.room_id) {
            dispatch(messageUpdate(lastMessage.room_id))

        }

        if (lastMessage.event === "notification") {
            // if(!lastMessage.content){
            //     Api.getChatMessage(lastMessage.room_id).then(res => setMessages(res.data))
            // }
            Api.seenChatMessage(lastMessage.message_id).then(l => {
                setMessages(prev => {
                    if (prev.some(m => m.id === lastMessage.message_id)) {
                        return prev;
                    }
                    return [...prev, { ...lastMessage, statuses: [{ seen: true }] }];
                });
            })
        }

    }, [isConnected, messages,]);


    const handleFiles = (ev) => {
        const list = ev.target.files;              // FileList
        const selected = list ? Array.from(list) : [];  // → array

        // log each file
        selected.forEach(f => console.log(f.name, f.size, f.type));
        console.log(selected);

        // replace existing files:
        setFiles(selected);

    }
    const textareaRef = useRef(null);
    useEffect(() => {
        (async () => {
            const { data } = await Api.getChatMessage(room)
            joinRoom(room)
            setMessages(data)

            return () => {
                leaveRoom(room)
            }
        })()
    }, [room])
    useEffect(() => {
        setMessages(prev => {
            prev.map(p => {
                if (p.id === isSeen) {
                    p.statuses[0].seen = true
                }
                return p
            })
            return prev
        })
    }, [isSeen])

    function formatMessageDate(dateString) {
        const date = moment.tz(dateString, "Asia/Yerevan"); // adjust to your DB timezone
        const now = moment.tz("Asia/Yerevan");

        if (date.year() === now.year()) {
            return date.format("DD/MM HH:mm");
        } else {
            return date.format("DD/MM/YYYY HH:mm");
        }
    }
    const handleInput = (e) => {
        const textarea = textareaRef.current;
        textarea.style.height = "auto"; // reset height
        textarea.style.height = `${textarea.scrollHeight}px`; // adjust height
        setValue(e.target.value);
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleSend = async () => {
        const tempMessage = {
            id: null,
            tempId: `temp-${Date.now()}`,
            content: value,
            username: login?.user?.email,
            timestamp: new Date().toISOString(),
            statuses: [{ seen: false }]
        };

        setMessages(prev => [...prev, tempMessage]);
        setValue('');
        const formData = new FormData()
        formData.append("content", value)
        files.forEach(f => formData.append("uploaded_files", f));
        const { data } = await Api.createChatMessage(room, formData);
        setFiles([])
        // Replace the temp message with the real one from server
        setMessages(prev =>
            prev.map(msg =>
                msg.tempId === tempMessage.tempId ? data : msg
            )
        );
    };
    return (
        <div>
            <div className='messageBlock'>
                <div className="chat-container">
                    {[...message].reverse().map((m, index) => {
                        return (
                            <div
                                key={m.id || `${m.timestamp}-${index}`} // fallback to timestamp-index
                                className={m.username === login?.user?.email ? "chat-message mine" : "chat-message others"}
                            >
                                <span>{m.content}</span>
                                {m.files?.length > 0 && (
                                    <div className="chat-files">
                                        {m.files.map((file, i) => {
                                            const fileUrl = file.file.startsWith("/media/")
                                                ? file.file
                                                : `${file.file}`;
                                            const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(fileUrl);

                                            return (
                                                <div key={i} className="chat-file">
                                                    {isImage ? (
                                                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                            <img
                                                                src={fileUrl}
                                                                alt="attachment"
                                                                style={{ maxWidth: "150px", maxHeight: "150px", borderRadius: "8px" }}
                                                            />
                                                        </a>
                                                    ) : (
                                                        <a
                                                            href={fileUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ margin: "10px 0", display: "inline-block", color: m.username === login?.user?.email?"white":"black", textDecoration: "underline" }}
                                                        >
                                                            📄 {(() => {
                                                                const name = fileUrl.split("/").pop();
                                                                return name.length > 10 ? name.slice(0, 10) + "…" : name;
                                                            })()}
                                                        </a>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                <p className='chat-message-footer'>
                                    <span>{formatMessageDate(m.timestamp)}</span>
                                    <span>
                                        {m.username === login?.user?.email ? <SeenIcon
                                            type={m.username === login?.user?.email ? "mine" : ''}
                                            status={m.statuses?.[0]?.seen ? "seen" : "delivered"}
                                        /> : null}
                                    </span>
                                </p>
                            </div>
                        );
                    })}
                </div>
                <div className="messageImage">
                    {files.map((f, i) =>
                        <div className='img' key={i}>
                            <span
                                className={(f.type === "image/jpeg") || (f.type === "image/png") ? 'icon-Photos' : "icon-files-empty"} />
                            <span className='images-name'>{f.name}</span>
                            <i className="fas fa-times" onClick={() => handleDeleteFile(i)} />
                        </div>
                    )}
                </div>
                <div className='messageFooter'>
                    <textarea
                        ref={textareaRef}
                        value={value}
                        onChange={handleInput}
                        placeholder="Type your message..."
                        className="chat-input"
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault(); // prevent newline
                              handleSend();       // send message
                            }
                          }}
                    />
                    <label>
                        <input type="file" onChange={handleFiles} multiple style={{ display: "none" }} />
                        <AttachFileIcon />
                    </label>

                    <SendIcon onClick={handleSend} />
                </div>
            </div>

        </div>
    )
}
